var map = {
	"./edit-page.svg": "oUGT",
	"./laptop.svg": "XBwc",
	"./mobile.svg": "6bt/",
	"./more-app.svg": "J7HL",
	"./variable-icon.svg": "1NaF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lue6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-manager/icon ^\.\/.*\.svg$
// module id = lue6
// module chunks = 46